import React, { useRef } from 'react';
import { observer } from 'mobx-react';
import classnames from 'classnames';

import { UiControlPropsType } from 'shared/types';
import { useObservable } from 'shared/hooks';

import { UiIcon } from '../UiIcon';

import './styles.scss';

type PropsType = UiControlPropsType<string | null> & {
    placeholder?: string,
    isOpened?: boolean,
    isReadOnly?: boolean,
    children?: React.ReactNode
};

export const UiDescription = observer(function UiDescription({
    value,
    className,
    isOpened,
    isReadOnly,
    name = 'ui-textarea',
    placeholder = 'Опишите, что нужно сделать',
    onChange = () => undefined,
    children
}: PropsType) {
    const ref = useRef<HTMLTextAreaElement>(null);
    const store = useObservable({
        isOpened,
        isFocused: false
    });

    const handleOpen = () => {
        store.set('isOpened', true);
        setTimeout(() => {
            if (ref?.current) {
                ref.current.focus();
            }
        }, 100);
    };

    if (!value && !store.isOpened) {
        if (isReadOnly) {
            return !children ? null : <div className={className}>{children}</div>;
        }

        return (
            <div className={classnames('ui-new-description-placeholder', className)} onClick={handleOpen}>
                <UiIcon.CirclePlus size={20} />
                <span>Добавить описание</span>
            </div>
        );
    }

    return (
        <div
            className={classnames('ui-new-description', className, {
                'ui-new-description--empty': !value,
                'ui-new-description--focus': store.isFocused,
                'ui-new-description--readonly': isReadOnly
            })}
        >
            <textarea
                ref={ref}
                onFocus={() => {
                    if (isReadOnly) {
                        return;
                    }
                    store.set('isFocused', true);
                }}
                onBlur={() => {
                    store.set('isFocused', false);
                }}
                className="ui-new-description__control"
                value={value || ''}
                readOnly={isReadOnly}
                onChange={e => {
                    onChange({ name, value: e.target.value || '' });
                }}
            />
            {!!children && (
                <div className="ui-new-description__children">
                    {children}
                </div>
            )}
            {!value && <div className="ui-new-description__placeholder">{placeholder}</div>}
            {(!!value && !isReadOnly) && (
                <div className="ui-new-description__clear">
                    <UiIcon.X
                        size={16}
                        onClick={() => {
                            onChange({
                                name,
                                value: '',
                            });
                        }}
                    />
                </div>
            )}
        </div>
    );
});
